import { LoveLanguage } from '@/types';

export interface TieQuoteReference {
  reference: string;
  displayReference: string;
}

export interface TieQuote {
  reference: string;
  text: string;
}

export const SINGLE_LANGUAGE_VERSES: Record<LoveLanguage, TieQuoteReference> = {
  [LoveLanguage.A]: {
    reference: 'Proverbs 16:24',
    displayReference: 'Proverbs 16:24',
  },
  [LoveLanguage.B]: {
    reference: 'Psalm 90:12',
    displayReference: 'Psalm 90:12',
  },
  [LoveLanguage.C]: {
    reference: 'James 1:17',
    displayReference: 'James 1:17',
  },
  [LoveLanguage.D]: {
    reference: 'Galatians 6:9',
    displayReference: 'Galatians 6:9',
  },
  [LoveLanguage.E]: {
    reference: '1 Corinthians 13:4-5',
    displayReference: '1 Corinthians 13:4-5',
  },
};

export const TIE_QUOTE_REFERENCES: Record<string, TieQuoteReference[]> = {
  A_B: [
    { reference: '1 Thessalonians 5:11', displayReference: '1 Thessalonians 5:11' },
    { reference: 'Hebrews 10:24-25', displayReference: 'Hebrews 10:24-25' },
    { reference: 'Proverbs 17:17', displayReference: 'Proverbs 17:17' },
  ],
  A_C: [
    { reference: 'James 1:17', displayReference: 'James 1:17' },
    { reference: 'Proverbs 11:25', displayReference: 'Proverbs 11:25' },
    { reference: 'Psalm 133:1,3', displayReference: 'Psalm 133:1,3' },
  ],
  A_D: [
    { reference: '1 John 3:18', displayReference: '1 John 3:18' },
    { reference: 'Isaiah 66:13', displayReference: 'Isaiah 66:13' },
    { reference: 'Colossians 3:12', displayReference: 'Colossians 3:12' },
  ],
  A_E: [
    { reference: 'John 14:27', displayReference: 'John 14:27' },
    { reference: '1 Peter 5:14', displayReference: '1 Peter 5:14' },
    { reference: '2 Corinthians 13:14', displayReference: '2 Corinthians 13:14' },
  ],
  B_C: [
    { reference: '1 Corinthians 13:13', displayReference: '1 Corinthians 13:13' },
    { reference: 'Ecclesiastes 3:1', displayReference: 'Ecclesiastes 3:1' },
    { reference: '3 John 1:13', displayReference: '3 John 1:13' },
  ],
  B_D: [
    { reference: 'Psalm 42:8', displayReference: 'Psalm 42:8' },
    { reference: 'Matthew 28:19-20', displayReference: 'Matthew 28:19-20' },
    { reference: 'Galatians 5:13', displayReference: 'Galatians 5:13' },
  ],
  B_E: [
    { reference: 'Romans 12:15', displayReference: 'Romans 12:15' },
    { reference: 'Song of Solomon 4:10', displayReference: 'Song of Solomon 4:10' },
    { reference: 'Song of Solomon 2:6', displayReference: 'Song of Solomon 2:6' },
  ],
  C_D: [
    { reference: 'Acts 20:35', displayReference: 'Acts 20:35' },
    { reference: 'Psalm 28:7', displayReference: 'Psalm 28:7' },
    { reference: '1 John 3:17', displayReference: '1 John 3:17' },
  ],
  C_E: [
    { reference: 'Song of Solomon 7:6', displayReference: 'Song of Solomon 7:6' },
    { reference: 'Isaiah 49:16', displayReference: 'Isaiah 49:16' },
    { reference: 'Psalm 116:15', displayReference: 'Psalm 116:15' },
  ],
  D_E: [
    { reference: 'Mark 10:16', displayReference: 'Mark 10:16' },
    { reference: 'Ephesians 4:25', displayReference: 'Ephesians 4:25' },
    { reference: 'Mark 12:30', displayReference: 'Mark 12:30' },
  ],
  A_B_C: [
    { reference: '1 Corinthians 13:13', displayReference: '1 Corinthians 13:13' },
    { reference: '1 Corinthians 16:14', displayReference: '1 Corinthians 16:14' },
  ],
  A_B_D: [
    { reference: 'Colossians 3:15', displayReference: 'Colossians 3:15' },
    { reference: 'Colossians 3:12', displayReference: 'Colossians 3:12' },
  ],
  A_B_E: [
    { reference: 'Ephesians 3:16-17', displayReference: 'Ephesians 3:16-17' },
    { reference: 'Philippians 1:11', displayReference: 'Philippians 1:11' },
  ],
  A_C_D: [
    { reference: 'Ephesians 4:2', displayReference: 'Ephesians 4:2' },
    { reference: 'Colossians 3:17', displayReference: 'Colossians 3:17' },
  ],
  A_C_E: [
    { reference: 'Psalm 133:1-2', displayReference: 'Psalm 133:1-2' },
  ],
  A_D_E: [
    { reference: '1 Thessalonians 5:11', displayReference: '1 Thessalonians 5:11' },
    { reference: '1 Peter 5:10', displayReference: '1 Peter 5:10' },
  ],
  B_C_D: [
    { reference: 'Philippians 2:3-4', displayReference: 'Philippians 2:3-4' },
    { reference: 'Psalm 89:15', displayReference: 'Psalm 89:15' },
  ],
  B_C_E: [
    { reference: '2 Corinthians 9:8', displayReference: '2 Corinthians 9:8' },
    { reference: 'Song of Solomon 2:10', displayReference: 'Song of Solomon 2:10' },
  ],
  B_D_E: [
    { reference: 'Galatians 6:2', displayReference: 'Galatians 6:2' },
    { reference: 'Ecclesiastes 4:9-10', displayReference: 'Ecclesiastes 4:9-10' },
  ],
  C_D_E: [
    { reference: 'Song of Solomon 7:10', displayReference: 'Song of Solomon 7:10' },
    { reference: 'Matthew 7:12', displayReference: 'Matthew 7:12' },
  ],
  A_B_C_D: [
    { reference: 'Ephesians 3:20-21', displayReference: 'Ephesians 3:20-21' },
    { reference: '1 Corinthians 13:8', displayReference: '1 Corinthians 13:8' },
  ],
  A_B_C_E: [
    { reference: '2 Timothy 2:22', displayReference: '2 Timothy 2:22' },
  ],
  A_B_D_E: [
    { reference: '1 Corinthians 13:12', displayReference: '1 Corinthians 13:12' },
  ],
  A_C_D_E: [
    { reference: 'Galatians 5:14', displayReference: 'Galatians 5:14' },
  ],
  B_C_D_E: [
    { reference: 'Philippians 4:19', displayReference: 'Philippians 4:19' },
  ],
  A_B_C_D_E: [
    { reference: '1 Corinthians 13:13', displayReference: '1 Corinthians 13:13' },
    { reference: '1 John 1:5', displayReference: '1 John 1:5' },
    { reference: '2 Corinthians 13:14', displayReference: '2 Corinthians 13:14' },
  ],
};

export function getTieKey(languages: LoveLanguage[]): string {
  return languages.sort().join('_');
}

export function getTieQuoteReferences(languages: LoveLanguage[]): TieQuoteReference[] {
  const key = getTieKey(languages);
  return TIE_QUOTE_REFERENCES[key] || [];
}

export function getSingleLanguageVerse(language: LoveLanguage): TieQuoteReference | null {
  return SINGLE_LANGUAGE_VERSES[language] || null;
}

export function getAllTieReferences(): string[] {
  const set = new Set<string>();
  Object.values(TIE_QUOTE_REFERENCES).forEach((arr) => {
    arr.forEach((ref) => set.add(ref.reference));
  });
  Object.values(SINGLE_LANGUAGE_VERSES).forEach((ref) => {
    set.add(ref.reference);
  });
  return Array.from(set);
}

export function detectTopTie(scores: Record<LoveLanguage, number>): LoveLanguage[] {
  const entries = Object.entries(scores) as [LoveLanguage, number][];
  const maxScore = Math.max(...entries.map(([, score]) => score));
  const tiedLanguages = entries
    .filter(([, score]) => score === maxScore)
    .map(([lang]) => lang);

  return tiedLanguages.length > 1 ? tiedLanguages : [];
}
